export default __webpack_public_path__ + "static/media/logo.99947a24.png";